import React, { useState, useEffect } from 'react'
import { Image } from "react-bootstrap";
import { firestore } from '../../firebase/firebase-utils'
import { withRouter } from 'react-router-dom'
import Pagination from '../../Text-Editor/Pagination'

function Feeds(props) {
    const [feeds, setFeeds] = useState([])
    const [Loading, setLoading] = useState(false);
    const [CurrentPage, setCurrentPage] = useState(1);
    const PostsPerPage = 10;

    const ref = firestore.collection('technews');
    const getPosts = () => {
        setLoading(true);
        ref.orderBy('query', 'desc').onSnapshot((querySnapshot) => {
            const posts = querySnapshot.docs.map(doc => {
                return {
                    ...doc.data(),
                    id: doc.id
                }
            })
            setFeeds(posts.slice(0,150));
            setLoading(false);
        })
    }
    useEffect(() => {
        getPosts()
        // eslint-disable-next-line
    }, [])

    // get current page posts
    const indexOfLastPost = CurrentPage * PostsPerPage;
    const indexOfFirstPost = indexOfLastPost - PostsPerPage;
    const currentPosts = feeds.slice(indexOfFirstPost, indexOfLastPost);

    //setting current page
    const setCurrent = (e)=>{
        setCurrentPage(e)
    }

    const getFullPost = (id) => {
        props.history.push('/technews/' + id)
    }
    return (
        <>
            {Loading ? "loading..." : ''}
            <div style={{minHeight:'70vh'}}>
                {currentPosts.map((feed) => (
                    <div key={feed.query} onClick={() => getFullPost(feed.id)} className="hoverCard">
                        <Image className="Img" src={feed.img} fluid />
                        <div style={{ paddingLeft: '10px' }}>
                            <h6>{feed.title}</h6>
                            <p className="author">Author: <span style={{ color: 'blue' }}>{feed.author}</span></p>
                        </div>
                    </div>
                ))
                }
            </div>
            <br/>
            <div className="scrollMenu">
                <Pagination totalPosts={feeds.length} postsPerPage={PostsPerPage} setCurrentPage={setCurrent}/>
            </div>
        </>
    )
}

function Trending(props) {
    const [feeds, setFeeds] = useState([])
    const [Loading, setLoading] = useState(false)

    const ref = firestore.collection('technews')
    const getPosts = () => {
        setLoading(true);
        ref.orderBy('query', 'desc').onSnapshot((querySnapshot) => {
            // eslint-disable-next-line
            var posts = querySnapshot.docs.map(doc => {
                var count = doc.data().keys.reduce((acc, elem) => {
                    return elem === "Trending" ? acc + 1 : acc
                }, 0)
                if (count !== 0) {
                    return {
                        ...doc.data(),
                        id: doc.id
                    }
                }
            });
            posts = posts.filter(result => (result !== undefined))
            setFeeds(posts);
            setLoading(false);
        })
    }

    useEffect(() => {
        getPosts()
        // eslint-disable-next-line
    }, [])


    const getFullPost = (id) => {
        props.history.push('/technews/' + id)
    }
    return (
        <>
            {Loading ? "loading..." : ''}
            {feeds.slice(0, 10).map((feed) => (
                <div key={feed.query} onClick={() => getFullPost(feed.id)} className="trending">
                    <hr />
                    <h6 style={{ color: '#057BD0' }}>{feed.title}</h6>
                </div>
            ))
            }
        </>
    )
}

export const TrendingFeeds = withRouter(Trending);
export default Feeds;